import React from 'react';
import styled from 'styled-components';

const MobileScrollContainer = styled.div`
  height: calc(100vh - 150px);
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  
  /* Estilos para la barra de scroll */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: hsl(220, 13%, 95%);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: hsl(220, 13%, 70%);
    border-radius: 3px;
    
    &:hover {
      background: hsl(220, 13%, 60%);
    }
  }
`;

const MobileScrollWrapper = ({ children }) => {
  return (
    <MobileScrollContainer>
      {children}
    </MobileScrollContainer>
  );
};

export default MobileScrollWrapper;